export async function getDesignSystemTranslations(locale: string) {
  return (await import(`./messages/${locale}.json`)).default;
}
